import React, { useState, useRef } from 'react';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [text, setText] = useState('');
  const [textarea, setTextarea] = useState('');
  const formRef = useRef();

  const sendEmail = () => {

    emailjs.send('service_bjpgkqi', 'template_qjfh8yw', {
      to_name: `${name}`,
      to_email: `${email}`,
      number: `${number}`,
      subject: `${text}`,
      message: `${textarea}`,
    }, 'ZKDb-KTJxDluMblPe')
      .then(
        (response) => {
          console.log('Email sent:', response);
          Swal.fire({
            title: 'Success!',
            text: 'Email Sent Successfully!',
            icon: 'success',
          });
        },
        (error) => {
          console.error('Email send failed:', error);
          Swal.fire({
            title: 'Error!',
            text: 'Failed to send email',
            icon: 'error',
          });
        }
      );

    // Clear the form fields after sending the email
    setName('');
    setEmail('');
    setNumber('');
    setText('');
    setTextarea('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      Swal.fire({
        title: 'Error!',
        text: 'Please enter a valid email address',
        icon: 'error',
      });
      return;
    }
    sendEmail();
  };

  const handleKeyDown = (e) => {
    // Check if the Enter key is pressed (key code 13)
    if (e.keyCode === 13) {
      handleSubmit(e);
    }
  };

  // Function to validate email
  const validateEmail = (email) => {
    // Regular expression for email validation
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  return (
    <>
      <div id="Contact" className='py-28'>
        <div className="Contact-Section">
          <h2 data-aos="zoom-in-down" className='pb-16 pt-2'><span>Contact</span> Me!</h2>
        </div>

        <section>
          <form id="form" ref={formRef} action="/" onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
            <div className="input-box">
              <div className="input-field" data-aos="zoom-in-up">
                <input
                  type="text"
                  name="Name"
                  id="name"
                  placeholder="Full Name"
                  required
                  value={name}
                  autoComplete='off'
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="input-field" data-aos="zoom-in-up">
                <input
                  type="email"
                  name="Email"
                  id="email"
                  placeholder="Email Address"
                  required
                  value={email}
                  autoComplete='off'
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
            <div className="input-box">
              <div className="input-field" data-aos="zoom-in-up">
                <input
                  type="number"
                  name="Number"
                  id="number"
                  placeholder="Phone Number"
                  required
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                />
              </div>
              <div className="input-field" data-aos="zoom-in-up">
                <input
                  type="text"
                  name="Text"
                  id="text"
                  placeholder="Email Subject"
                  required
                  value={text}
                  autoComplete='off'
                  onChange={(e) => setText(e.target.value)}
                />
              </div>
            </div>
            <div className="textarea-field" data-aos="zoom-in-up">
              <textarea
                name="Textarea"
                id="textarea"
                cols="60"
                rows="10"
                placeholder="Your Message"
                required
                value={textarea}
                onChange={(e) => setTextarea(e.target.value)}
              ></textarea>
            </div>
            <button data-aos="zoom-in" type="submit" className="btn4 font-normal py-2 px-5 mt-10">Send Message</button>
          </form>
        </section>
      </div>
    </>
  );
}

export default Contact;
